import * as React from 'react';
import { useAccountOrderOpbFordMcOpbLimiteText } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountOrderOpbFordMcOpbLimite = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountOrderOpbFordMcOpbLimiteText();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
